import { differenceInWeeks, format } from 'date-fns';

import type { PlayerPoolMember } from '~/domains/contest/domains/services/interfaces/player-pool-member.interface';

const formatNextGameDate = (date?: Date) => {
  if (!date || Number.isNaN(date?.getTime())) {
    return;
  }

  // Mobile spec: always display like "Thu 8:20 PM"
  const dateString = format(date, 'EEE h:mm a');
  return dateString;
};

const formatNextGame = (date: Date) => {
  const dateString = formatNextGameDate(date) ?? '';

  return dateString;
};

const parseInjuryTag = (pick: PlayerPoolMember) => {
  if (pick.attributes?.injury?.abbrStatus) {
    return pick.attributes.injury?.abbrStatus.toUpperCase();
  }

  // Fallback if abbrStatus is not present
  switch (pick.attributes?.injury?.status?.toLowerCase()) {
    case 'out':
      return 'OUT';
    case 'questionable':
      return 'Q';
    case 'doubtful':
      return 'D';
    case 'gtd':
      return 'GTD';
    default:
      return undefined;
  }
};

const parseName = (name: string) => {
  const [firstName, ...lastName] = name.split(' ');

  return `${firstName[0]}. ${lastName.join(' ')}`;
};

export { formatNextGame, formatNextGameDate, parseInjuryTag, parseName };
